import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ConfirmationMessageModule,
  MessageModule
} from '@spartacus/organization/administration/components';
import {
  I18nModule,
} from '@spartacus/core';
import { UigUserToggleStatusComponent } from './uig-user-toggle-status.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    MessageModule,
    ConfirmationMessageModule
  ],
  declarations: [UigUserToggleStatusComponent],
  exports: [UigUserToggleStatusComponent]
})
export class UigUserToggleStatusModule { }
